// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"eb92c6bc","239":"1fe69269","455":"d3830275","488":"5b2aa171"}[chunkId] + ".chunk.js";
};